import React, { useEffect, useState } from "react";
import { ContentPanel } from "components/displays";
import {
  ListBuilder,
  ActionBar,
  FormBuilder,
  usePreferences,
  Form,
} from "@redriver/cinnamon";
import { TablePagination } from "components/pagination";
import {
  ConfigurableTable,
  TableConfigurator,
} from "features/CustomConfig/TableConfig";
import { getScheduleCreditNotes } from "../actions";
import { AddModalWrapper } from "components/modals";
import {
  numericFormatter,
  dateFormatter,
  blankDataFormatter,
} from "components/displays/DisplayHelper";
import { FilterGrid } from ".";
import { Image } from "semantic-ui-react";
import Search from "features/../../../shared/assets/purple-search.svg";

const ScheduleCreditNote = () => {
  const { preferences } = usePreferences();
  const [config, setConfig] = useState(
    preferences.scheduleCreditNoteTableConfig,
  );
  const [pageSizeConfig, setPageSizeConfig] = useState(
    preferences.scheduleCreditNoteTableConfigPageSize
      ? preferences.scheduleCreditNoteTableConfigPageSize
      : 25,
  );

  const [selectedItems, setSelected] = useState({});

  useEffect(() => {
    setConfig(preferences.scheduleCreditNoteTableConfig);
  }, [preferences.scheduleCreditNoteTableConfig]);

  useEffect(() => {
    preferences.scheduleCreditNoteTableConfigPageSize &&
      setPageSizeConfig(preferences.scheduleCreditNoteTableConfigPageSize);
  }, [preferences.scheduleCreditNoteTableConfigPageSize]);

  const columns = [
    {
      field: "id",
      title: "Selectable Column",
      selectableColumn: true,
      sortable: false,
    },
    { field: "customer", title: "Customer", width: "20em" },
    { field: "customerIdentifier", title: "Customer ID", width: "10em" },
    { field: "scheduleNumber", title: "Schedule Number" },
    { field: "supplier", title: "Supplier" },
    { field: "supplierOffice", title: "Supplier Office" },
    { field: "spv", title: "SPV" },
    { field: "scheduleStatus", title: "Schedule Status" },
    {
      field: "taxDate",
      title: "Tax Date",
      render: (item) => dateFormatter(item.taxDate),
    },
    { field: "invoiceSubtype", title: "Invoice Subtype" },
    { field: "invoicingPeriod", title: "Invoicing Period" },
    {
      field: "monthInQtr",
      title: "Month in Quarter",
      render: (item) => blankDataFormatter(item.monthInQtr, "N/A"),
    },
    {
      field: "meterDueDate",
      title: "Meter Due Date",
      render: (item) => dateFormatter(item.meterDueDate),
    },
    { field: "currency", title: "Currency" },
    {
      field: "netValue",
      title: "Net Value (£)",
      render: (item) => numericFormatter(item.netValue, 0, 2),
    },
  ];

  // Ticket 365516: Hiding any non-functional pages that are using mocked up data.
  return null;

  return (
    <ListBuilder
      withTable
      initialPagination={{ pageSize: pageSizeConfig, pageNumber: 1 }}
      dataTransform={(data) => data.results}
      totalTransform={(data) => data.totalResults}
      loadAction={getScheduleCreditNotes}
      loadParams={{ pageSize: pageSizeConfig }}
      renderList={(tableProps, state, events) => (
        <ContentPanel
          title=""
          wrapperCssClass="outline-grid customer-billing-list schedule-credit-note"
          headerCssClass="defaults-page-title"
          headerContent={
            <FilterBar
              state={state}
              events={events}
              config={config}
              columns={columns}
              initialPageSize={25}
              pageSizeConfig={pageSizeConfig}
            ></FilterBar>
          }
        >
          <div className="spaced">
            <div className="vertical-scrollbar large">
              <ConfigurableTable
                state={state}
                events={events}
                tableProps={tableProps}
                emptyMessage="No credit notes found"
                columns={columns}
                config={config}
                selectedItems={selectedItems}
                setSelected={setSelected}
              />
            </div>
            <div className="padded">
              <TablePagination
                pageSize={pageSizeConfig}
                pageNumber={state.pagination.pageNumber}
                onChange={events.onChangePagination}
                totalItems={state.total}
              />
            </div>
            <div className="footer">
              <AddModalWrapper title="Create Selected Credit Note/s">
                Not Implemented
              </AddModalWrapper>
            </div>
          </div>
        </ContentPanel>
      )}
    />
  );
};

const FilterBar = ({
  state,
  events,
  config,
  columns,
  initialPageSize,
  pageSizeConfig,
}) => (
  <FormBuilder
    value={state.filters}
    onChange={events.onChangeFilters}
    renderForm={(formProps) => (
      <Form {...formProps}>
        <ActionBar className="filter-display">
          <ActionBar.Item>
            <h4 className="finance-title">Schedule Credit Note</h4>
            <div className="sml-screen">
              <TableConfigurator
                config={config}
                columns={columns}
                configId="scheduleCreditNoteTableConfig"
                titlePreFix="Schedule Credit Note"
                initialPageSize={initialPageSize}
                pageSizeConfig={pageSizeConfig}
              />
            </div>
            <AddModalWrapper title="Add Credit Note for Schedule Invoice">
              Not Implemented
            </AddModalWrapper>
            <div className="text-search-wrapper">
              <Form.Input
                field="search"
                placeholder="Search"
                icon={<Image src={Search} />}
                className="search-input highlighted-input"
              />
            </div>
          </ActionBar.Item>
          <ActionBar.Item fluid></ActionBar.Item>
          <ActionBar.Item className="right-header-col">
            <FilterGrid
              config={config}
              columns={columns}
              configId="scheduleCreditNoteTableConfig"
              titlePreFix="Schedule Credit Note"
              initialPageSize={initialPageSize}
              pageSizeConfig={pageSizeConfig}
            />
          </ActionBar.Item>
        </ActionBar>
      </Form>
    )}
  />
);

export default ScheduleCreditNote;
